var Shadows;
(function(Shadows2) {
  Shadows2["elevation5"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.1)";
  Shadows2["elevation6"] = "0px 5px 10px 0px rgba(0, 0, 0, 0.2)";
  Shadows2["elevation10"] = "0px 20px 30px 0px rgba(0, 0, 0, 0.1)";
  Shadows2["elevation20"] = "0px 10px 30px 0px rgba(0, 0, 0, 0.2)";
  Shadows2["elevation30"] = "0px 10px 20px 0px rgba(0, 0, 0, 0.3)";
})(Shadows || (Shadows = {}));

export { Shadows };
//# sourceMappingURL=Shadows.es.js.map
